import { useState } from "react"
import styled from "styled-components"

const LoginContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`

const LoginForm = styled.form`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
`

const Title = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #555;
`

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #667eea;
  }
`

const Button = styled.button`
  background: #667eea;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.3s;

  &:hover {
    background: #5a6fd8;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`

const ErrorMessage = styled.div`
  color: #dc3545;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0.5rem;
  background: #f8d7da;
  border-radius: 4px;
`

const LoginPage = ({ onLogin, apiEndpoints = {} }) => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  })
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setCredentials((prev) => ({
      ...prev,
      [name]: value || "",
    }))
    setError("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError("")

    try {
      // Try API authentication first
      let apiSuccess = false
      if (apiEndpoints.login) {
        try {
          const response = await fetch(apiEndpoints.login, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: credentials.username || "",
              password: credentials.password || "",
            }),
          })

          if (response?.ok) {
            const result = await response.json()
            if (result?.success && result?.data?.token) {
              localStorage.setItem("adminToken", result.data.token)
              localStorage.setItem("isAdminLoggedIn", "true")
              apiSuccess = true
              onLogin()
            }
          }
        } catch (apiError) {
          console.error("API login failed:", apiError)
        }
      }

      // Fallback to dummy authentication
      if (!apiSuccess) {
        if ((credentials.username || "") === "admin" && (credentials.password || "") === "admin123") {
          localStorage.setItem("isAdminLoggedIn", "true")
          onLogin()
        } else {
          setError("Invalid username or password")
        }
      }
    } catch (error) {
      console.error("Login error:", error)
      setError("Login failed. Please try again.")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <LoginContainer>
      <LoginForm onSubmit={handleSubmit}>
        <Title>Admin Login</Title>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <FormGroup>
          <Label htmlFor="username">Username</Label>
          <Input
            type="text"
            id="username"
            name="username"
            value={credentials.username || ""}
            onChange={handleInputChange}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="password">Password</Label>
          <Input
            type="password"
            id="password"
            name="password"
            value={credentials.password || ""}
            onChange={handleInputChange}
            required
          />
        </FormGroup>

        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Logging in..." : "Login"}
        </Button>
        <div style={{ marginTop: "1rem", textAlign: "center", fontSize: "0.9rem", color: "#666" }}>
          Demo credentials: admin / admin123
        </div>
      </LoginForm>
    </LoginContainer>
  )
}

export default LoginPage
